import React from 'react';
import { Star, ExternalLink } from 'lucide-react';

const Reviews = () => {
  return (
    <section className="bg-[#f3f3f1]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="flex items-center gap-3 mb-10">
          <span className="block w-7 h-[2px] bg-[#e30613]" />
          <h3 className="font-bold tracking-[0.22em] text-[13px] text-[#1c1c1c]">OPINIE KLIENTÓW</h3>
        </div>

        <div className="grid lg:grid-cols-[1fr_auto] gap-10 items-center">
          {/* Stars + tagline */}
          <div className="flex flex-col items-start">
            <div className="flex items-center gap-2 text-[#f6b500]">
              {[...Array(5)].map((_, k) => (
                <Star key={k} size={44} fill="#f6b500" stroke="#f6b500" />
              ))}
            </div>
            <div className="mt-5 flex items-baseline gap-3">
              <span className="text-[44px] md:text-[52px] font-black text-[#1c1c1c] leading-none">5.0</span>
              <span className="text-[13px] tracking-[0.18em] text-[#666] uppercase">w Google</span>
            </div>
            <p className="mt-5 text-[14px] text-[#444] leading-relaxed max-w-[560px] whitespace-pre-line">
{`Zaufanie nie rodzi się z rozmowy.
Nie z reklamy, nie z obietnic.

Rodzi się dopiero wtedy, kiedy przyjdzie deszcz — i wszystko, co miało puścić, puszcza.
Albo nie.

Reszta to już nie nasze słowa.
To ludzie mówią. Bez filtra. Bez poprawiania.`}
            </p>
          </div>

          {/* Big CTA button */}
          <a
            href="https://www.google.com/search?sca_esv=bab5d0a3aacebeff&rlz=1C5MACD_enPL1151PL1151&biw=2138&bih=1117&sxsrf=ANbL-n5oF-sZJ47CfSBsMzyYSUKeXjNdGQ:1777297529434&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOTJ4HLhlVaY1WUflY-v8MDYS1R3zVuIzzlfLCG-JP3FaV0BT0_nGH3zK4MdooVQXl7fHBQArXETo7nP6SewAxvfPNeMpC4W6ftCTQNgmBKgVkNr7N6BeFS_9LIL95W2xbXL8mvaK2daJDXJoc4AKwWxmGNt_zJ8YJqWFk-xliigY2BpwvA%3D%3D&q=LSTOIT.pl+%7C+dachy+p%C5%82askie,+obr%C3%B3bki+blacharskie+%7CResitrix,+Hertalan,+TPO,+EPDM+Opinie&sa=X&ved=2ahUKEwi0upuflY6UAxVYGhAIHaaYNxkQ0bkNegQIHxAH"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-3 bg-[#1c1c1c] hover:bg-[#e30613] text-white text-[12px] md:text-[13px] tracking-[0.2em] font-semibold px-8 md:px-10 py-5 md:py-6 transition-colors duration-200 shadow-lg shadow-black/10"
          >
            ZOBACZ WSZYSTKIE OPINIE NA GOOGLE
            <ExternalLink size={16} className="group-hover:translate-x-1 transition-transform duration-200" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
